import { OrderPaymentStatus, OrderStatus } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';

export const ORDER_STATUS_ICON: Record<OrderStatus, NoddiIconName> = {
  [OrderStatus.ACTIVE]: 'Zap',
  [OrderStatus.CANCELLED]: 'CircleX',
  [OrderStatus.INVOICED]: 'ReceiptText',
  [OrderStatus.DRAFT]: 'Edit',
  [OrderStatus.WAITING_FOR_PAYMENT]: 'Clock',
  [OrderStatus.PAID_PENDING_RESOLUTION]: 'Search',
  [OrderStatus.COMPLETED]: 'CircleCheck',
  [OrderStatus.DELETED_NOT_PAID]: 'Trash2'
};

export const ORDER_PAYMENT_STATUS_ICON: Record<OrderPaymentStatus, NoddiIconName> = {
  [OrderPaymentStatus.CANCELLED]: 'CircleX',
  [OrderPaymentStatus.DISPUTED]: 'Flag',
  [OrderPaymentStatus.OVERPAID]: 'TrendingUp',
  [OrderPaymentStatus.PAID]: 'CircleDollarSign',
  [OrderPaymentStatus.PAID_EXTERNAL]: 'Store',
  [OrderPaymentStatus.PARTIALLY_PAID]: 'ChartPie',
  [OrderPaymentStatus.PARTIALLY_REFUNDED]: 'RotateCcw',
  [OrderPaymentStatus.REFUNDED]: 'Undo2',
  [OrderPaymentStatus.UNPAID]: 'DollarSign'
};
